import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";

import { useLocation } from "react-router-dom";
import moment from "moment";
import { toWords } from "number-to-words";
const Invoice = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    reset,
  } = useForm();

  const { state } = useLocation();

  const selectFormat = watch("selectFormat");

  const isA5 = selectFormat == "a5";

  console.log("state", state);

  const details = localStorage.getItem("companyDetails");
  const companyDetails = details ? JSON.parse(details) : null;

  let totalAmount = 0;
  let quantity = 0;
  let totalItems = 0;
  let totalPrice = 0;
  let totalwithoutAmount = 0;

  const amount = state?.orderProducts?.reduce((total, item) => {
    const qty = Number(item?.quantity || 0);
    const price = Number(item?.unitPrice || 0);
    return total + qty * price;
  }, 0);

  const discount = Number(state?.discountPrice || 0);
  const gstRate = Number(state?.gstPercentage || 0);

  const totalDiscountedAmount = Number(amount) - Number(discount);
  const totalDiscountedAmountWithoutGst = Number(amount) - Number(discount);

  const gstAmount = (Number(totalDiscountedAmount) * Number(gstRate)) / 100;

  const downloadPDF = async (mode) => {
    // Get the wrapper element
    const wrapper = document.getElementById("wrapper");

    // Clone the wrapper to avoid modifying the original DOM
    const clone = wrapper.cloneNode(true);

    // Remove header and footer if mode is 'letterpad'
    if (mode === "letterpad") {
      const clonedHeader = clone.querySelector("#header");
      const clonedFooter = clone.querySelector("#footer");
      if (clonedHeader) clonedHeader.remove();
      if (clonedFooter) clonedFooter.remove();

      clone.style.paddingTop = "0mm";
    }

    // Apply custom styles to avoid breaking inside tables (page break behavior)
    clone.querySelectorAll("table, tr").forEach((el) => {
      el.style.pageBreakInside = "avoid"; // CSS to avoid page break inside
      el.style.breakInside = "avoid"; // Another CSS to avoid break
    });

    // Set style for cloned element to hide off-screen
    clone.style.position = "absolute";
    clone.style.left = "-9999px";
    document.body.appendChild(clone);

    // Create canvas from the clone of the DOM element
    const canvas = await html2canvas(clone, { scale: 1, useCORS: true });

    // Convert canvas to image data URL (PNG format)
    const imgData = canvas.toDataURL("image/png");

    // Initialize jsPDF for generating the PDF
    // const pdf = new jsPDF("p", "mm", [210, 400]);
    const pdf = new jsPDF({
      unit: "mm",
      format: isA5 ? "a5" : "a4",
      orientation: isA5 ? "landscape" : "portrait",
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Get image properties for aspect ratio scaling
    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pageWidth) / imgProps.width;

    let heightLeft = imgHeight; // Remaining height for the image
    let position = 0; // Initial position of the image on the first page

    // Add the first page with the image
    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
    heightLeft -= pageHeight;

    // Loop to handle multiple pages if content overflows
    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage(); // Create a new page
      pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight); // Add image to new page
      heightLeft -= pageHeight;
    }

    // Save the PDF with the specified filename
    pdf.save("Invoice.pdf");

    // Remove the cloned wrapper from the DOM after the PDF is generated
    document.body.removeChild(clone);
  };

  let sgst = 0;
  let cgst = 0;
  let scgstAmt = 0;

  let sumOfNetAmt = 0;
  let nontaxamount = 0;
  let totalnewbalance = 0;
  let taxGroups = {};
  let igstnetAmount = 0;

  const overallBalance = 0;

  const pendingbalance = Number(
    state?.payments?.[state?.payments?.length - 1]?.balanceAmount || 0
  );

  const receivedbalance = Number(
    state?.payments?.[state?.payments?.length - 1]?.receivedAmount || 0
  );

  const totalOutstanding = pendingbalance + receivedbalance;

  // const remainingbalance = pendingbalance - receivedbalance;

  return (
    <>
      <section className="invoice_main_section">
        <div id="wrapper">
          <main className="my-2  p-0" id="content">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-12 col-lg-4 p-1"
                  style={{ border: "1px solid black" }}
                >
                  <div className="company-name">
                    {companyDetails?.shopName || ""}
                  </div>
                  <p className="invoice_address_part my-0">
                    {`${companyDetails?.companyAddress || ""} , ${
                      companyDetails?.companyLocation || ""
                    } ,${companyDetails?.district || ""} ,PIN-${
                      companyDetails?.companyPincode || ""
                    } `}{" "}
                    <br />
                    TamilNadu &nbsp;&nbsp; Phone No :{" "}
                    {companyDetails?.customerPhno || ""}
                  </p>
                  <table>
                    <tbody>
                      <tr>
                        <td className="invoice_sub_title">GSTIN</td>
                        <td className="invoice_address_part">
                          {" "}
                          <b> : </b> {companyDetails?.gstNumber || ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  className="col-12 col-lg-4 p-2"
                  style={{ border: "1px solid black" }}
                >
                  <table>
                    <tr>
                      <td colSpan="2">
                        <p className="invoice_cus_address">
                          <b>{state?.customerName || ""}</b>
                        </p>
                        <p className="invoice_address_part">
                          {` ${state?.customerAddress || ""},   ${
                            state?.pincode
                          }, ${state?.state || ""}`}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      {/* <td className="invoice_sub_title">CONTACT</td> */}
                      <td colSpan="2">
                        <p className="invoice_address_part">
                          {" "}
                          {state?.contact || ""}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="invoice_address_part">GSTIN</td>
                      <td>
                        <p className="invoice_address_part">
                          : {state?.gstNumber}
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  className="col-12 col-lg-4 p-2"
                  style={{ border: "1px solid black" }}
                >
                  <h6 className="company-name">TAX INVOICE</h6>
                  <table>
                    <tbody>
                      <tr>
                        <td className="invoice_sub_title">Invoice No</td>
                        <td className="invoice_sub_title">
                          {" "}
                          : {state?.invoiceNo || ""}
                        </td>
                      </tr>
                      <tr>
                        <td className="invoice_sub_title">Date</td>
                        <td className="invoice_sub_title">
                          {" "}
                          :{" "}
                          {state?.salesDate
                            ? moment(state?.salesDate).format("DD-MM-YYYY")
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td className="invoice_sub_title">Mode</td>
                        <td className="invoice_sub_title">
                          {" "}
                          : {state?.transactionMode || ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <table className="overall_table">
              <thead>
                <tr>
                  <th className="overall_table_heading">SNO</th>
                  <th className="overall_table_heading">Goods Description</th>
                  <th className="overall_table_heading">HSN Code</th>
                  <th className="overall_table_heading">MRP</th>
                  <th className="overall_table_heading">Qty</th>
                  <th className="overall_table_heading">
                    Rate
                    <br />
                    (Before Tax)
                  </th>
                  <th className="overall_table_heading" colSpan="2">
                    IGST
                  </th>

                  <th className="overall_table_heading" colSpan="2">
                    CGST
                  </th>
                  <th className="overall_table_heading" colSpan="2">
                    SGST
                  </th>
                  <th className="overall_table_heading">Net Rate</th>
                  <th className="overall_table_heading">Net Amount</th>
                </tr>
              </thead>
              <tbody>
                {state &&
                  state?.orderProducts?.map((item, i) => {
                    const unitPrice = Number(item?.unitPrice || 0);
                    const qty = Number(item?.quantity || 0);
                    const gstPercent = Number(item?.gstPercentage || 0);

                    const sgstandcgst = gstPercent / 2;

                    const gstAmount = (unitPrice * gstPercent) / 100;
                    const netRate = unitPrice + gstAmount;
                    const netAmount = netRate * qty;

                    const gstAmountForAll = +((gstAmount * qty) / 2).toFixed(2); // CGST or SGST
                    const igstAmountForAll = +(gstAmount * qty).toFixed(2); // Total GST for IGST

                    const isTamilNadu =
                      state?.state?.toLowerCase().replace(/\s+/g, "") ===
                      "tamilnadu";

                    // Accumulate totals
                    sumOfNetAmt += netAmount;

                    if (gstPercent === 0) {
                      nontaxamount += netAmount;
                    } else {
                      taxGroups[gstPercent] =
                        (taxGroups[gstPercent] || 0) + igstAmountForAll;
                    }

                    totalAmount += netAmount;
                    quantity += qty;
                    totalItems += 1;
                    totalnewbalance =
                      Number(overallBalance || 0) + Math.round(sumOfNetAmt);

                    return (
                      <tr key={i}>
                        <td className="invoice_table_product_data">{i + 1}</td>
                        <td className="invoice_table_product_data">
                          {item?.product?.toUpperCase() || "-"}
                        </td>
                        <td className="invoice_table_product_data">
                          {item?.hsnCode || "-"}
                        </td>
                        <td className="invoice_table_product_data">
                          {item?.mrpPrice || "-"}
                        </td>
                        <td className="invoice_table_product_data">
                          {item?.quantity || "-"}
                        </td>
                        <td className="invoice_table_product_data">
                          {item?.unitPrice || "-"}
                        </td>

                        {/* IGST % */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? "0.00" : gstPercent}
                        </td>
                        {/* IGST Amount */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? "0.00" : igstAmountForAll.toFixed(2)}
                        </td>

                        {/* CGST % */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? sgstandcgst : "0.00"}
                        </td>
                        {/* CGST Amount */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? gstAmountForAll.toFixed(2) : "0.00"}
                        </td>

                        {/* SGST % */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? sgstandcgst : "0.00"}
                        </td>
                        {/* SGST Amount */}
                        <td className="invoice_table_product_data">
                          {isTamilNadu ? gstAmountForAll.toFixed(2) : "0.00"}
                        </td>

                        {/* Net Rate */}
                        <td className="invoice_table_product_data">
                          {netRate.toFixed(2)}
                        </td>

                        {/* Net Amount */}
                        <td className="invoice_table_product_data">
                          {netAmount.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
                <tr>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data">
                    {" "}
                    <br />
                    SUB TOTAL
                    <br />
                    ROUNDED-OFF
                  </td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td
                    className="invoice_table_product_data"
                    style={{ borderTop: "1px solid black" }}
                  >
                    {Math.round(sumOfNetAmt).toLocaleString("en-IN")}
                  </td>
                </tr>
                <tr>
                  <td className="invoice_table_product_data"></td>
                  <td
                    className="invoice_table_product_data"
                    style={{ border: "1px solid black" }}
                  >
                    <p className="overall_report_bill justify-content-end">
                      <b>TXBLAMT</b>
                    </p>
                    <p className="overall_report_bill">
                      <span>SALES NT</span>
                      <span>{Number(nontaxamount || 0).toFixed(2) || 0}</span>
                    </p>

                    {Object.entries(taxGroups).map(([gstRate, amount], idx) => (
                      <p className="overall_report_bill" key={idx}>
                        <span>SALES {gstRate}%</span>
                        <span>{Number(amount).toFixed(2)}</span>
                      </p>
                    ))}
                  </td>
                  <td
                    className="invoice_table_product_data"
                    colSpan="2"
                    style={{ border: "1px solid black" }}
                  >
                    <p className="overall_report_bill">CGST</p>
                    {Object.entries(taxGroups).map(([gstRate, amount], idx) => (
                      <p className="overall_report_bill" key={idx}>
                        <span>
                          {state?.state?.toLowerCase().replace(/\s+/g, "") ===
                          "tamilnadu"
                            ? `${(gstRate / 2).toFixed(2)}%`
                            : "0.00"}
                        </span>
                        <span>
                          {state?.state?.toLowerCase().replace(/\s+/g, "") ===
                          "tamilnadu"
                            ? (amount / 2).toFixed(2)
                            : "0.00"}
                        </span>
                      </p>
                    ))}
                  </td>

                  <td
                    className="invoice_table_product_data"
                    colSpan="2"
                    style={{ border: "1px solid black" }}
                  >
                    <p className="overall_report_bill">SGST</p>
                    {Object.entries(taxGroups).map(([gstRate, amount], idx) => (
                      <p className="overall_report_bill" key={idx}>
                        <span>
                          {state?.state?.toLowerCase().replace(/\s+/g, "") ===
                          "tamilnadu"
                            ? `${(gstRate / 2).toFixed(2)}%`
                            : "0.00"}
                        </span>
                        <span>
                          {state?.state?.toLowerCase().replace(/\s+/g, "") ===
                          "tamilnadu"
                            ? (amount / 2).toFixed(2)
                            : "0.00"}
                        </span>
                      </p>
                    ))}
                  </td>

                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                  <td className="invoice_table_product_data"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td
                    colSpan="2"
                    className="overall_footer_data"
                    style={{ border: "1px solid black" }}
                  >
                    TOTAL{" "}
                  </td>
                  <td
                    colSpan="12"
                    className="overall_footer_data"
                    style={{ border: "1px solid black" }}
                  >
                    Rs.
                    {state?.payments?.length == 0
                      ? Math.round(sumOfNetAmt).toLocaleString("en-IN")
                      : Math.round(Number(sumOfNetAmt || 0)).toLocaleString(
                          "en-IN"
                        )}
                  </td>
                </tr>
                <tr>
                  <td
                    className="invoice_table_product_data"
                    colSpan="6"
                    style={{ border: "1px solid black" }}
                  >
                    RUPEES &nbsp;
                    {/* {toWords(Number(sumOfNetAmt) || 0).toUpperCase()} */}
                    {toWords(
                      Math.round(Number(sumOfNetAmt) || 0)
                    ).toUpperCase()}
                    &nbsp; ONLY
                    <br />
                    <b>Excutive : {state?.executiveName || "-"}</b>
                    <br />
                    <b>Vehicle No : {state?.vehiclenumber || "-"}</b>
                    <p className="text-end mt-4 mb-0">Party Signature</p>
                  </td>
                  <td className="invoice_table_product_data" colSpan="8">
                    Previous Balance : <b>{state?.balanceAmount || 0}</b>
                    <br />
                    <b>
                      Received Now. Rs.
                      {receivedbalance.toLocaleString("en-IN") || 0}
                    </b>
                    <br />
                    Current Balance{" "}
                    <b>Rs.{pendingbalance.toLocaleString("en-IN") || 0}</b>
                    <p className="text-end mt-4 mb-0">Signature</p>
                  </td>
                </tr>
              </tfoot>
            </table>
          </main>
        </div>
        <div className="d-flex justify-content-center my-3 gap-2">
          <Controller
            name="selectFormat"
            control={control}
            defaultValue="a5"
            render={({ field }) => (
              <select {...field} className="invoice_download_btn">
                <option value="a4">A4 </option>
                <option value="a5">A5 </option>
              </select>
            )}
          />
          <button
            onClick={() => downloadPDF("letterpad")}
            // className="download_btn"
            style={{ borderRadius: "6px" }}
            className="invoice_download_btn"
          >
            Download
          </button>
        </div>
      </section>
    </>
  );
};

export default Invoice;
